export default __webpack_public_path__ + "static/media/chevron-double-right.e57d0afa.svg";